import { render, staticRenderFns } from "./tExchange.vue?vue&type=template&id=522dec02&scoped=true"
import script from "./tExchange.vue?vue&type=script&lang=js"
export * from "./tExchange.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "522dec02",
  null
  
)

export default component.exports